import * as types from '../constants';

const initialState = {
  roomListTotal: 0,
  roomListItems: [],
  viewType: 'card',
  currentPageNumber: 1,
  paginationItem: {
    offset: 0,
    limit: 100,
  },
  filterItem: {
    buildingId: '',
    floorId: '',
  },
};

const RoomListReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.INIT_ROOM_LIST_STATE:
      return {
        ...state,
        roomListTotal: 0,
        roomListItems: [],
        currentPageNumber: 1,
        paginationItem: {
          offset: 0,
          limit: 100,
        },
        filterItem: {
          buildingId: '',
          floorId: '',
        },
      };
    case types.SET_VIEW_TYPE:
      return {
        ...state,
        viewType: action.payload,
      };
    case types.SET_ROOM_LIST:
      return {
        ...state,
        roomListTotal: action.payload.total,
        roomListItems: action.payload.items,
      };
    case types.SET_ROOM_LIST_CURRENT_PAGE_NUMBER:
      return {
        ...state,
        currentPageNumber: action.payload,
      };
    case types.SET_ROOM_PAGINATION_ITEM:
      return {
        ...state,
        paginationItem: action.payload,
      };
    case types.SET_ROOM_FILTER_ITEM:
      return {
        ...state,
        filterItem: action.payload,
      };
    default:
      return state;
  }
};

export default RoomListReducer;